import React from 'react'

const EmployeeModuleSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_3153_50734)" />
    <path
      d="M34.9518 49.4959C31.4294 49.4959 27.9612 49.4959 24.4388 49.4959C22.7589 49.4959 22.1628 48.7373 22.4338 47.1658C23.4634 41.3132 28.5031 36.9238 34.3557 36.707C40.5334 36.4902 46.0066 40.5545 47.4156 46.3529C48.0117 48.7373 47.4156 49.4959 44.977 49.4959C41.6172 49.4959 38.3116 49.4959 34.9518 49.4959Z"
      fill="white"
    />
    <path
      d="M35.0057 20.5042C38.7991 20.5042 41.8337 23.4846 41.8337 27.2238C41.8337 30.8545 38.6365 33.9976 34.9515 33.9976C31.2666 33.9976 28.1777 30.8545 28.1777 27.1696C28.1777 23.4304 31.1582 20.5042 35.0057 20.5042Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3153_50734"
        x1="35"
        y1="0"
        x2="35"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0B62B5" />
        <stop offset="1" stop-color="#003F7C" />
      </linearGradient>
    </defs>
  </svg>
)

export default EmployeeModuleSubcategory
